export default __webpack_public_path__ + "static/media/gallery_08.894f4acf.jpg";